import Route from '@ember/routing/route';

class TokenLoginRoute extends Route {
  get _location() {
    return window.location;
  }
  model(params) {
    if (!params.token) {
      return;
    }
    const loc = this._location;
    const baseUrl = loc.href.replace(/token[-_]login.*$/, '');
    loc.replace(`${baseUrl}?access_token=${encodeURIComponent(params.token)}`);
  }
}

export { TokenLoginRoute as default };
//# sourceMappingURL=token-login.js.map
